<script setup lang="ts">
import ItpFormSelect from './ItpFormSelect.vue';

defineOptions({ name: 'ItpSelect2', inheritAttrs: false });

const props = defineProps<{ name: string }>();
</script>

<template>
  <ItpFormSelect v-bind="$attrs" :name="props.name" mode="rich">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </ItpFormSelect>
</template>
